"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var MarketplaceCXIdMappingContext = /** @class */ (function () {
    function MarketplaceCXIdMappingContext(marketplaceId) {
        this._marketplaceId = marketplaceId;
    }
    MarketplaceCXIdMappingContext.prototype.toRawContext = function () {
        var context = new Map();
        context.set("acs_marketplace_id", this._marketplaceId);
        return new amazon_config_store_type_script_client_1.QueryContext(context);
    };
    Object.defineProperty(MarketplaceCXIdMappingContext.prototype, "marketplaceId", {
        get: function () {
            return this._marketplaceId;
        },
        set: function (value) {
            this._marketplaceId = value;
        },
        enumerable: false,
        configurable: true
    });
    return MarketplaceCXIdMappingContext;
}());
exports.default = MarketplaceCXIdMappingContext;
